import { TFunction } from 'i18next'
import { z } from 'zod'

export const createNotificationSchema = (t: TFunction) =>
  z.object({
    personalName: z.string().min(1, {
      message: t('required'),
    }),
    phoneNumber: z.string().min(1, {
      message: t('required'),
    }),
    email: z
      .string()
      .email({ message: t('invalidEmail') })
      .min(5, {
        message: t('required'),
      }),
    messageBody: z.string().min(1, {
      message: t('required'),
    }),
  })
